import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import dayjs, { Dayjs } from 'dayjs';

export class DocumentExtractionBankStatementMeta extends BaseEntityModel {
  parentId?: string;
  startDate?: string;
  endDate?: string;

  constructor(model: Partial<DocumentExtractionBankStatementMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.startDate = model.startDate;
    this.endDate = model.endDate;
  }

  get dayjsStartDate(): Dayjs | null {
    return this.startDate ? dayjs(this.startDate) : null;
  }

  get dayjsEndDate(): Dayjs | null {
    return this.endDate ? dayjs(this.endDate) : null;
  }
}
